<template>
  <div class="records">
    <el-card>
      <div class="records_title">
        <div class="records_title_left"><el-image :src="peropeData.headPortraitKey" /></div>
        <div class="records_title_right">
          <p>{{ peropeData.name }}</p>
          <div class="records_title_right_bottom">基本介绍：{{ peropeData.selfAssessment }}</div>
        </div>
      </div>
      <div class="records_btn">
        <el-button class="records_btn_color" type="primary" @click="addClick()">添加记录</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="talentProgress" label="人才进度" align="center"></el-table-column>
        <el-table-column prop="talentDetails" label="人才详况" align="center"></el-table-column>
        <el-table-column
          prop="operationConsultant"
          label="操作顾问"
          align="center"
        ></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" align="center"></el-table-column>
        <el-table-column class="operation" width="120" label="操作" align="center">
          <template v-slot="{ row }">
            <div class="operation_bottom">
              <dic-button @buttonClick="editItem(row)" icon="icon-jr-icon-modify" text="编辑" />
              <dic-button @buttonClick="deleteItem(row)" icon="icon-jr-icon-delete" text="删除" />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        :title="dialogType ? '编辑候选人记录' : '添加候选人记录'"
        :visible.sync="dialogVisible"
        width="50%"
        @close="handleClose"
      >
        <el-form
          ref="form"
          :rules="rules"
          style="margin-top: 20px"
          :model="recordFrom"
          label-width="120px"
        >
          <div class="form_flex">
            <el-form-item label="项目阶段：" prop="talentProgress">
              <el-select
                @change="optionChange"
                v-model="recordFrom.talentProgress"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.codeId"
                  :label="item.codeName"
                  :value="item.codeName"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作顾问：" prop="operationConsultant">
              <p>{{ recordFrom.operationConsultant }}</p>
            </el-form-item>
          </div>
          <el-form-item label="上传附件：">
            <upload-file
              :lookUrl.sync="recordFrom.uploadAttachments"
              :saveUrl.sync="recordFrom.uploadAttachmentsKey"
            />
          </el-form-item>
          <el-form-item label="是否入职：" v-if="itemShow">
            <el-radio-group v-model="recordFrom.employment">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="new_menoy" v-if="recordFrom.employment * 1">
            <div class="new_menoy_title">薪资待遇：</div>
            <el-form-item class="new_left">
              <div class="menony_flex">
                <div class="menony_flex_left">
                  <div class="menony_flex_item">
                    <span>年薪：</span>
                    <el-input v-model="recordFrom.annualSalary" />
                  </div>
                </div>
                <div class="menony_flex_center">
                  <span>薪资构成</span>
                  <div></div>
                </div>
                <div class="menony_flex_right">
                  <div class="menony_flex_right_li">
                    <div class="menony_flex_item">
                      <span>固定月薪：</span>
                      <el-input v-model="recordFrom.monthlySalary" />
                    </div>
                    <div class="menony_flex_item">
                      <span>年度奖金：</span>
                      <el-input v-model="recordFrom.annualBonus" />
                    </div>
                  </div>
                  <div class="menony_flex_right_li">
                    <div class="menony_flex_item">
                      <span>绩效奖金：</span>
                      <el-input v-model="recordFrom.achievementBonus" />
                    </div>
                    <div class="menony_flex_item">
                      <span>提成：</span>
                      <el-input v-model="recordFrom.commission" />
                    </div>
                  </div>
                  <div class="menony_flex_right_li">
                    <div class="menony_flex_right_li_item">
                      <span>其他：</span>
                      <el-input v-model="recordFrom.other" type="textarea" :rows="3" />
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="项目详况：" prop="talentDetails">
            <el-input v-model="recordFrom.talentDetails" type="textarea" :rows="5" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
const defaultrecordObj = {
  achievementBonus: '', //绩效奖金
  annualBonus: '', //年度奖金
  annualSalary: '', //年薪
  commission: '', //提成
  createName: '', //创建人名字
  createTime: '', //创建时间
  employment: '', //是否入职 0-否 1-是
  id: '', //id
  monthlySalary: '', //固定月薪
  operationConsultant: '', //操作顾问
  other: '', //其他
  personnelId: '', //人才关联id
  projectId: '', //项目中心编号
  talentDetails: '', //人才详况
  talentProgress: '', //人才进度
  updateName: '', //修改人名字
  updateTime: '', //修改时间
  uploadAttachments: '', //上传附件
  uploadAttachmentsKey: ''
}
import { pagination } from '@/mixins/pagination'
import { codeType } from '@/api/common.js'
import {
  getPersonListById,
  addRecords,
  updateRecords,
  selectCandidateRecords,
  getListByOne,
  deleteRecords
} from '@/api/records.js'
import UploadFile from '../../../../../../components/UploadFile.vue'
import DicButton from '../../../../../../components/DicButton.vue'
export default {
  components: { UploadFile, DicButton },
  name: 'Records',
  mixins: [pagination],
  data() {
    return {
      tableData: [], //表格数据
      rules: {
        talentProgress: [{ required: true, message: '请选择项目阶段', trigger: 'change' }],
        talentDetails: [{ required: true, message: '请输入项目详况', trigger: 'blur' }]
      }, //规则
      peropeData: {
        name: '',
        selfAssessment: '',
        headPortraitKey: ''
      },
      queryInfo: {
        pageNum: 0,
        pageSize: 10,
        id: '',
        order: ''
      },
      dialogVisible: false,
      dialogType: 0,
      recordFrom: { ...defaultrecordObj },
      options: [],
      itemShow: false //是否入职展示
    }
  },
  computed: {
    personCode() {
      return this.$route.query.personCode
    },
    projectId() {
      return this.$route.query.projectId
    }
  },
  created() {
    this.particularsPersonByid() //根据id查询人才
    this.search() //查询一览
    this.codePro() //查询项目阶段的code表
    this.recordFrom.operationConsultant = sessionStorage.getItem('userName')
  },
  methods: {
    addClick() {
      this.dialogVisible = true
      this.dialogVisibleType = 0
      this.recordFrom.operationConsultant = sessionStorage.getItem('userName')
    },
    //submitForm 编辑、新增确定
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res
          if (this.dialogType) {
            this.recordFrom.operationConsultant = sessionStorage.getItem('userName')
            res = await updateRecords(this.recordFrom)
          } else {
            this.recordFrom.personnelId = this.personCode
            this.recordFrom.projectId = this.projectId
            res = await addRecords(this.recordFrom)
          }
          if (res.data.resultCode === 200) {
            this.$message.success(`${this.dialogType ? '编辑' : '新增'}成功`)
            this.dialogVisible = false
            this.search()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    //编辑
    async editItem(row) {
      const { data: res } = await getListByOne({ id: row.id })
      if (res.resultCode === 200) {
        this.dialogType = 1
        this.dialogVisible = true
        Object.assign(this.recordFrom, res.data)
        if (this.recordFrom.employment === '1') {
          this.itemShow = true
        } else {
          this.itemShow = false
        }
      }
    },
    //删除
    deleteItem(row) {
      this.$confirm('确认删除吗 ?', '提示')
        .then(async () => {
          const { data: res } = await deleteRecords({ id: row.id })
          if (res.resultCode === 200) {
            this.$message.success('删除成功')
            this.search()
          }
        })
        .catch(() => {})
    },
    //选择项目阶段
    optionChange(val) {
      if (val === '已完成') {
        this.itemShow = true
      } else {
        this.itemShow = false
        this.recordFrom.employment = ''
      }
    },
    //查询项目阶段的code表
    async codePro() {
      const { data: res } = await codeType({ code: '012' })
      if (res.resultCode === 200) {
        this.options = res.data
      }
    },
    //根据id查询人才
    async particularsPersonByid() {
      const { data: res } = await getPersonListById({ personCode: this.personCode })
      if (res.resultCode === 200) {
        this.peropeData = res.data
      }
    },
    //查询一览
    async search() {
      this.queryInfo.id = this.personCode
      const { data: res } = await selectCandidateRecords(this.queryInfo)
      if (res.resultCode === 200) {
        this.tableData = res.data.list
        this.total = res.data.total
      }
    },
    //关闭弹窗
    handleClose() {
      this.$refs.form.resetFields()
      Object.assign(this.recordFrom, defaultrecordObj)
      if (!this.dialogType) {
        this.recordFrom.operationConsultant = sessionStorage.getItem('userName')
      }
      this.dialogVisible = false
      this.itemShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.records {
  width: 100%;

  .records_title {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 16px;
    background-color: #17757a;
    display: flex;
    flex-direction: row;

    .records_title_left {
      width: 94px;
      height: 88px;
      margin-right: 12px;

      .el-image {
        width: 94px;
        height: 88px;
        display: block;
      }
    }

    .records_title_right {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      p {
        color: #fff;
        font-family: 'PingFang SC';
        font-size: 18px;
        margin-bottom: 12px;
      }

      .records_title_right_bottom {
        color: #ffffff;
        font-size: 14px;
        line-height: 1.5em;
      }
    }
  }

  .records_btn {
    width: 100%;
    overflow: hidden;
    text-align: right;
    margin: 20px 0;
  }

  .form_flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow: hidden;

    /deep/.el-form-item {
      width: 50%;
    }
  }

  .menony_flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .menony_flex_item {
      display: flex;
      flex-direction: row;
      align-items: center;

      span {
        display: block;
        color: #606266;
        font-size: 14px;
        width: 80px;
        text-align: right;
      }

      /deep/ .el-input {
        width: 135px;
      }
    }

    .menony_flex_left {
      margin-right: 40px;
      overflow: hidden;
      width: 18%;
    }

    .menony_flex_center {
      width: 12%;
      margin-right: 40px;
      font-size: 14px;
      align-items: center;
      color: #000;
      display: flex;
      flex-direction: column;

      /deep/ span {
        line-height: 20px !important;
      }

      div {
        width: 100%;
        position: relative;
        height: 2px;
        margin-top: 8px;
        background-color: #eee;
      }
      div:before {
        position: absolute;
        top: 50%;
        right: 0;
        margin-top: -4px;
        content: ' ';
        display: inline-block;
        height: 6px;
        width: 6px;
        border-width: 2px 2px 0 0;
        border-color: #c8c8cd;
        border-style: solid;
        -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
        transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
      }

      div:after {
        content: ' ';
        position: absolute;
        right: 0;
        top: 0;
        width: 1px;
        bottom: 0;
        border-right: 1px solid #d9d9d9;
        color: #d9d9d9;
        -webkit-transform-origin: 100% 0;
        transform-origin: 100% 0;
        -webkit-transform: scaleX(0.5);
        transform: scaleX(0.5);
      }
    }

    .menony_flex_right {
      flex: 1;
      overflow: hidden;

      /deep/ .el-input {
        width: 184px !important;
      }

      .menony_flex_right_li {
        display: flex;
        flex-direction: row;
        margin-bottom: 20px;
        justify-content: space-between;
      }

      .menony_flex_right_li_item {
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        span {
          display: block;
          color: #606266;
          font-size: 14px;
          width: 80px;
          text-align: right;
        }

        /deep/ .el-textarea {
          flex: 1;
        }
      }
    }
  }

  .new_left {
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  .new_menoy_title {
    width: 120px;
    text-align: right;
    color: #606266;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
}
</style>
